var safeCb = require('./safeCb');
var each = require('./each');
exports = function(obj, predicate, ctx) {
    var ret = [];
    predicate = safeCb(predicate, ctx);
    each(obj, function(val, idx, list) {
        if (predicate(val, idx, list)) ret.push(val);
    });
    return ret;
};

module.exports = exports;
